// noinspection DuplicatedCode

import React, { useEffect, useRef, useState } from "react";
import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut, fetchDelete, fetchPostMultipartSeaweed } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";

const InsertAccountPayable = ({}) => {
  let initialState = {
    BisnisUnitID: "",
    Tanggal: new Date(),
    TanggalCek: new Date(),
  };

  let initialStateModal = {
    SDTDate: new Date(),
  };
  
  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const {
    changed,
    values,
    isValid,
    touched,
    submitHandler,
    customHandler,
    changeHandler,
    errors,
    blastChange,
  } = useForm(initialState, validations);

  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [modalDetail, setModalDetail] = useState(initialStateModal);
  const [tarifPajak, setTarifPajak] = useState(null);
  const [modalID, setModalID] = useState(0);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [downpaymentData, setDownpaymentData] = useState(null);
  const [selectedDownpayment, setSelectedDownpayment] = useState(null);

  // ── Lampiran data pendukung — pola sama dgn upload attachment di Kas Bank
  // (inser-kasbank.js): file diupload lewat layanan generik, hanya NAMA file
  // (ber-prefix UUID) yang disimpan di kolom "PembayaranAP"."File".
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [fileUploadError, setFileUploadError] = useState(false);
  const mutationFileUpload = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );

  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const param = useLocation();
  const params = useParams();

  const mutation = useMutation((formData) =>
    fetchPost("Master/UserPC", formData)
  );
  const mutationAdd = useMutation((formData) =>
    fetchPost("Accounting/PembayaranAP", formData)
  );
  const mutationGet = useMutation((formData) =>
    fetchGet("Accounting/PembayaranAP/" + formData)
  );
  const mutationUpdate = useMutation((formData) =>
    fetchPut("Accounting/PembayaranAP", formData)
  );
  const mutationRollback = useMutation((id) =>
    fetchDelete("Accounting/PembayaranAP/rollback/" + id)
  );
  const detailAccount = useMutation((formData) =>
    fetchGet("GetMinMasterDetailAccountV2")
  );
  
  // Mutation untuk cek pembayaran dengan endpoint baru
  const mutationCheckPayment = useMutation((params) =>
    fetchGet(`Accounting/Mon/CashJournal/forcheck?purchaseOrderID=${params.purchaseOrderID}&sumberData=${params.sumberData}`)
  );
  // DP tidak lagi dipilih di sini — ia melekat pada PO lewat MSR-nya, jadi yang
  // diambil adalah DP milik PO terpilih saja.
  const mutationGetDownpayment = useMutation((purchaseOrderID) =>
    fetchGet("Accounting/Downpayment/po/" + encodeURIComponent(purchaseOrderID))
  );

  const ModalEdit = (detail, id) => {
    setModalID(id);
    setModalDetail(detail);
    setShowModal(true);
    setShowModalEdit(true);
  };

  const ModalDelete = (id) => {
    const newDetail = detail.filter((_, i) => i !== id);
    let totals = 0;
    newDetail.forEach(({ Nominal }) => {
      totals += parseFloat(Nominal) || 0;
    });
    customHandler(parseFloat(values.Nominal || 0) + totals, "NilaiBayar");
    setDetail(newDetail);
  };

  const navigate = useNavigate();

  useEffect(() => {
    detailAccount.mutate();
    barang.mutate();
    if (params.transid) {
      mutationGet.mutate(params.transid);
    }
  }, []);

  // Ambil DP milik PO terpilih. Dipicu tiap PurchaseOrderID berubah — termasuk saat
  // pembayaran lama dibuka, di mana PO baru diketahui setelah data datang.
  useEffect(() => {
    const po = values.PurchaseOrderID;
    if (!po) {
      setSelectedDownpayment(null);
      return;
    }
    mutationGetDownpayment.mutate(po, {
      onSuccess: (res) => {
        const dp = res && res.status === "Success" ? res.data : null;
        if (dp && dp.CashJournalID) {
          setSelectedDownpayment(dp);
          setDownpaymentData({
            TotalDownpayment: dp.Nominal,
            DownpaymentAccountID: dp.DownpaymentAccountID,
          });
          // dp.Nominal = SISA uang muka yang belum terpakai termin lain.
          // Yang dipotong di termin ini dibatasi nominal terminnya sendiri;
          // kelebihannya tetap jadi aset untuk termin berikutnya. Dulu uang muka
          // dipotong penuh sementara Nilai Bayar dijepit ke 0, sehingga jurnalnya
          // timpang sebesar (uang muka − nominal termin).
          // Kebutuhan termin = Nominal + biaya tambahan bersih (PPN/PPh dst), sama dgn
          // porsiUangMuka di backend.
          const netBiaya = detail.reduce((t, r) => t + (parseFloat(r.Nominal) || 0), 0);
          const nominalTermin = (parseFloat(values.Nominal) || 0) + netBiaya;
          const dpTerpakai = Math.min(dp.Nominal, nominalTermin);
          customHandler(nominalTermin - dpTerpakai, "NilaiBayar");
        } else {
          setSelectedDownpayment(null);
          setDownpaymentData(null);
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.PurchaseOrderID, values.Nominal]);

  // Nominal termin diubah manual -> baris pajak otomatis ikut dihitung ulang.
  useEffect(() => {
    if (!tarifPajak || !detail.some((r) => r.OtomatisPajak)) return;
    const baru = [
      ...detail.filter((r) => !r.OtomatisPajak),
      ...bangunBarisPajak(values.Nominal, tarifPajak),
    ];
    const sama =
      baru.length === detail.length &&
      baru.every((r, i) => r.Nominal === detail[i].Nominal && r.Account === detail[i].Account);
    if (sama) return;
    setDetail(baru);
    const net = baru.reduce((t, r) => t + (parseFloat(r.Nominal) || 0), 0);
    customHandler((parseFloat(values.Nominal) || 0) + net, "NilaiBayar");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.Nominal]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/finance/pembayaran-ap");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (mutationAdd) {
      if (mutationAdd.isSuccess) {
        navigate("/finance/pembayaran-ap");
      }
    }
  }, [mutationAdd.status]);

  useEffect(() => {
    if (mutationGet.data) {
      let tempData = mutationGet.data.data;
      tempData["JenisCashJournal"] = mutationGet.data.data["JenisPembayaran"];
      tempData["DetailCashJournal"] = mutationGet.data.data["DetailPembayaran"];

      blastChange(tempData);

      if (Array.isArray(tempData.Data) && tempData.Data.length > 0) {
        setDetail(tempData.Data);
      }

      // DP tidak dicocokkan dari daftar lagi — efek PurchaseOrderID di atas yang
      // mengambilnya langsung dari MSR PO ini.
    }
  }, [mutationGet.status]);

  // Reset pilihan downpayment ketika PO berubah (list global tidak di-reset)
  useEffect(() => {
    if (values.SumberData) {
      setPaymentStatus(null);
      setDownpaymentData(null);
      setSelectedDownpayment(null);
    }
  }, [values.SumberData]);

  const header = [
    { name: "Account", key: "Account", modifiers: "Account" },
    { name: "Account Name", key: "Account", modifiers: "AccountName" },
    { name: "Keterangan", key: "Keterangan", modifiers: "Keterangan" },
    { name: "Nominal", key: "Nominal", modifiers: "Numbers" },
    { name: "tools", key: "EditDelete", modifiers: "EditDelete" },
  ];

  const modalHandler = (value, names) => {
    const newValues = { ...modalDetail, [names]: value };
    setModalDetail(newValues);
  };

  // NumberFormat (react-number-format) memanggil onValueChange dengan objek
  // {formattedValue, value, floatValue} — bukan event DOM — sehingga tampilan
  // boleh berpemisah-ribuan sementara nilai yang disimpan tetap angka murni.
  const modalHandlerNominal = (values) => {
    const newValues = { ...modalDetail, Nominal: values.floatValue?.toString() || "" };
    setModalDetail(newValues);
  };

  const checkPaymentStatus = async (purchaseOrderID, sumberData) => {
    console.log("Checking payment status for:", { purchaseOrderID, sumberData });
    
    if (!purchaseOrderID && !sumberData) {
      console.log("No purchaseOrderID or sumberData provided");
      return;
    }
    
    setLoadingCheck(true);
    setPaymentStatus(null);
    
    try {
      console.log("Calling API with params:", { purchaseOrderID, sumberData });
      
      // Panggil endpoint baru dengan query parameters
      const result = await mutationCheckPayment.mutateAsync({
        purchaseOrderID: purchaseOrderID || "",
        sumberData: sumberData || ""
      });
      
      console.log("API Response:", result);
      
      if (result && result.status === "Success" && result.data) {
        // Data berupa array, cari PO yang sesuai
        const dataArray = result.data;
        
        // Cari data dengan PurchaseOrderID yang sesuai
        let existingPayment = null;
        
        if (purchaseOrderID) {
          // Cari berdasarkan PurchaseOrderID
          existingPayment = dataArray.find(item => 
            item.PurchaseOrderID === purchaseOrderID
          );
        }
        
        // Jika tidak ketemu dengan PurchaseOrderID, coba cari dengan SumberData
        if (!existingPayment && sumberData) {
          existingPayment = dataArray.find(item => 
            item.SumberData === sumberData || 
            (item.PurchaseOrderID && item.PurchaseOrderID.includes(sumberData))
          );
        }
        
        if (existingPayment) {
          // PO sudah dibayar
          console.log("Found existing payment:", existingPayment);
          
          setPaymentStatus({
            isPaid: true,
            message: `PO ${purchaseOrderID || sumberData} sudah dibayar melalui pembayaran Non PO(Sebagai uang Muka)`,
            keterangan: existingPayment.Keterangan || "Tidak ada keterangan",
            tanggal: existingPayment.Tanggal,
            nominal: existingPayment.Nominal,
            cashJournalID: existingPayment.CashJournalID,
            purchaseOrderID: existingPayment.PurchaseOrderID,
            sumberData: existingPayment.SumberData,
            status: existingPayment.Status,
            dariKepada: existingPayment.DariKepada,
            jenisTransaksi: existingPayment.JenisTransaksi,
            jenisCashJournal: existingPayment.JenisCashJournal,
            detailCashJournal: existingPayment.DetailCashJournal,
            noCek: existingPayment.NoCek
          });
          
          // Tampilkan alert
          setTimeout(() => {
            alert(
              `PO ${purchaseOrderID || sumberData} sudah dibayar!\n\n` +
              `Cash Journal ID: ${existingPayment.CashJournalID || '-'}\n` +
              `Tanggal: ${existingPayment.Tanggal ? new Date(existingPayment.Tanggal).toLocaleDateString() : '-'}\n` +
              `Nominal: Rp ${parseFloat(existingPayment.Nominal || 0).toLocaleString('id-ID')}\n` +
              `Keterangan: ${existingPayment.Keterangan || '-'}\n` +
              `Status: ${existingPayment.Status || '-'}\n` +
              `Dibayarkan Kepada: ${existingPayment.DariKepada || '-'}\n` +
              `Purchase Order ID: ${existingPayment.PurchaseOrderID || '-'}\n` +
              `No. Cek: ${existingPayment.NoCek || '-'}`
            );
          }, 100);
        } else {
          // PO belum dibayar
          console.log("PO belum dibayar - tidak ditemukan dalam data");
          setPaymentStatus({
            isPaid: false,
            message: `PO ${purchaseOrderID || sumberData} belum dibayar`
          });
        }
      } else {
        setPaymentStatus({
          isPaid: null,
          message: result?.message || "Gagal memeriksa status pembayaran"
        });
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
      setPaymentStatus({
        isPaid: null,
        message: `Gagal memeriksa status pembayaran: ${error.message}`
      });
    } finally {
      setLoadingCheck(false);
    }
  };

  // Baris PPN/PPh/PBBKB otomatis dari tarif PO (PRComparison), dihitung dari Nominal termin
  // (DPP). Hasilnya jadi baris biaya tambahan seperti input manual — jurnal AP menggabungkannya
  // ke Dr Hutang Pengadaan, dan NilaiBayar = Nominal + PPN + PBBKB - PPh. PPh negatif (dipotong).
  const bangunBarisPajak = (nominal, t) => {
    if (!t) return [];
    const dpp = parseFloat(nominal) || 0;
    const po = t.PurchaseOrderID ? " PO " + t.PurchaseOrderID : "";
    const defs = [
      { rate: parseFloat(t.Ppn) || 0, Account: "2105001", label: "PPN", sign: 1 },
      { rate: parseFloat(t.Pbbkb) || 0, Account: "2116001", label: "PBBKB", sign: 1 },
      { rate: parseFloat(t.Pph) || 0, Account: "2103003", label: "PPh", sign: -1 },
    ];
    return defs
      .filter((d) => d.rate > 0 && dpp > 0)
      .map((d) => ({
        Account: d.Account,
        Keterangan: `${d.label} ${d.rate}%${po}`,
        Nominal: String(d.sign * Math.round(dpp * d.rate / 100)),
        OtomatisPajak: true,
      }));
  };

  const sumberDataHandler = async (value) => {
    const grandTotal = parseFloat(value.GrandTotal) || 0;

    // Biaya Lain-lain dari Price Comparison (2026-10-14): di LUAR nominal pokok (pra-pajak)
    // supaya PPN yang diisi di sini tak ikut membesar; otomatis jadi baris biaya tambahan
    // (jurnal AP menggabungkannya ke Dr Hutang Pengadaan — sejalan dgn jurnal GA yang
    // meng-Kredit Hutang sebesar Biaya Lain-lain). Baris otomatis dari pilihan sebelumnya
    // dibuang dulu agar tak tertinggal saat sumber diganti.
    const biayaLain = parseFloat(value.BiayaLain) || 0;
    const tarif = {
      PurchaseOrderID: value.PurchaseOrderID,
      Ppn: value.Ppn,
      Pph: value.Pph,
      Pbbkb: value.Pbbkb,
    };
    setTarifPajak(tarif);
    const barisLain = [
      ...detail.filter((r) => !r.OtomatisBiayaLain && !r.OtomatisPajak),
      ...bangunBarisPajak(grandTotal, tarif),
    ];
    const detailBaru =
      biayaLain > 0
        ? [
            ...barisLain,
            {
              Account: value.BiayaLainAccountID || "",
              Keterangan:
                "Biaya lain-lain" +
                (value.KeteranganBiayaLain ? ": " + value.KeteranganBiayaLain : ""),
              Nominal: String(biayaLain),
              OtomatisBiayaLain: true,
            },
          ]
        : barisLain;
    setDetail(detailBaru);
    const totalBaris = detailBaru.reduce((t, r) => t + (parseFloat(r.Nominal) || 0), 0);

    // Reset pilihan DP (list global sudah di-load saat form buka)
    setSelectedDownpayment(null);
    setDownpaymentData(null);

    blastChange({
      SumberData: value.value,
      PurchaseOrderID: value.PurchaseOrderID,
      DibayarKepada: value.NamaSupplier,
      Tanggal: new Date(),
      // Fallback "Rupiah": field ini disabled (read-only) di form, jadi kalau
      // PRComparison sumbernya kebetulan tak punya Currency (data gap - pernah
      // terjadi pada 5 PO), user terjebak tak bisa submit sama sekali karena
      // tak ada cara mengisinya manual. Seluruh transaksi di sistem ini
      // memang Rupiah (lih. fallback identik di cashjournal.go).
      MataUang: value.Currency || "Rupiah",
      KonversiRupiah: 0,
      Nominal: grandTotal,
      NilaiBayar: grandTotal + totalBaris,
      TanggalCek: new Date(),
    });

    if (value.PurchaseOrderID && value.PurchaseOrderID.trim() !== "") {
      await checkPaymentStatus(value.PurchaseOrderID, value.value);
    } else if (value.value && value.value.trim() !== "") {
      await checkPaymentStatus("", value.value);
    } else {
      setPaymentStatus(null);
    }
  };

  const modalHandlerWithBody = (value) => {
    const newValues = {
      ...modalDetail,
      ["NomorAccount"]: value.value,
      ["NamaAccount"]: value.label,
    };
    setModalDetail(newValues);
  };

  const modalHandlerText = (event) => {
    const newValues = {
      ...modalDetail,
      [event.target.name]: event.target.value,
    };
    setModalDetail(newValues);
  };

  const inputBuilder = [
    {
      type: "DetailAccount",
      name: "Account",
      title: "Account",
      handler: modalHandler,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "text",
      name: "Keterangan",
      title: "Keterangan",
      handler: modalHandlerText,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
    {
      type: "numberFormatSatu",
      name: "Nominal",
      title: "Nominal",
      handler: modalHandlerNominal,
      size: "full",
      required: false,
      disabled: false,
      edit: false,
    },
  ];

  // getDataFromURL - buka/unduh lampiran. Sama persis dgn pola Kas Bank
  // (inser-kasbank.js): PDF/gambar dibuka tab baru, format lain didownload.
  const getDataFromURL = (url) => {
    if (!url || url.trim() === "") {
      toast.error("Tidak ada file attachment", {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }
    const encodedUrl = encodeURIComponent(url);
    const fileUrl = `${process.env.REACT_APP_API_UPLOAD_URL}file/${encodedUrl}`;

    fetch(fileUrl, { method: "GET", headers: { Accept: "application/octet-stream" } })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.blob();
      })
      .then((blob) => {
        const fileBlobUrl = window.URL.createObjectURL(blob);
        if (blob.type.includes("pdf") || blob.type.includes("image")) {
          window.open(fileBlobUrl, "_blank");
        } else {
          const link = document.createElement("a");
          link.href = fileBlobUrl;
          let downloadName = url;
          if (url.includes("-") && url.split("-")[0].length === 36) {
            downloadName = url.split("-").slice(1).join("-").replace(/_/g, " ");
          }
          link.download = downloadName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setTimeout(() => URL.revokeObjectURL(fileBlobUrl), 100);
        }
      })
      .catch((err) => {
        console.error("Error loading file:", err);
        toast.error("Gagal membuka file. File mungkin belum diupload ke server.", {
          position: "bottom-right",
          autoClose: 3000,
        });
      });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      toast.error("Ukuran file maksimal 10MB!", { position: "bottom-right", autoClose: 3000 });
      event.target.value = "";
      return;
    }
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Format file tidak didukung! Gunakan PDF, JPG, PNG, atau DOC.", {
        position: "bottom-right",
        autoClose: 3000,
      });
      event.target.value = "";
      return;
    }

    setSelectedFile(file);
    setFileUploadError(false);
    toast.success("File siap diupload", { position: "bottom-right", autoClose: 2000 });
  };

  const removeFile = () => {
    setSelectedFile(null);
    setUploadedFileName("");
    setFileUploadError(false);
    customHandler("", "File");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const getDisplayFileName = () => {
    if (selectedFile) return selectedFile.name;
    const f = uploadedFileName || values.File;
    if (!f) return null;
    if (f.includes("-") && f.split("-")[0].length === 36) {
      return f.split("-").slice(1).join("-").replace(/_/g, " ");
    }
    return f;
  };
  const displayFileName = getDisplayFileName();

  const Kirim = async () => {
    // Cek apakah PO sudah dibayar sebelum melanjutkan
    if (paymentStatus && paymentStatus.isPaid) {
      const confirmContinue = window.confirm(
        `PO ${values.PurchaseOrderID} sudah dibayar pada tanggal ${paymentStatus.tanggal ? new Date(paymentStatus.tanggal).toLocaleDateString() : 'tidak diketahui'}. Apakah Anda yakin ingin melanjutkan pembayaran?`
      );

      if (!confirmContinue) {
        return;
      }
    }

    let newValues = values;

    try {
      newValues["Nominal"] = newValues["Nominal"].toString();
      newValues["JenisPembayaran"] = newValues["JenisCashJournal"].toString();
      newValues["DetailPembayaran"] = newValues["DetailCashJournal"].toString();
      newValues["NilaiBayar"] = newValues["NilaiBayar"].toString();
      newValues["JenisTransaksi"] = "AP";
      newValues["KonversiRupiah"] = newValues["KonversiRupiah"].toString();
      newValues["DownpaymentAmount"] = selectedDownpayment ? selectedDownpayment.Nominal.toString() : "0";
      newValues["DownpaymentAccountID"] = selectedDownpayment ? selectedDownpayment.DownpaymentAccountID : "";
      newValues["DownpaymentCashJournalID"] = selectedDownpayment ? selectedDownpayment.CashJournalID : "";

      newValues["TanggalCek"] = newValues["TanggalCek"].toISOString();

      newValues["Tanggal"] = newValues["Tanggal"].toISOString();
    } catch (err) {}

    newValues["Data"] = detail;

    // Upload lampiran (kalau ada file baru dipilih) SEBELUM submit header, sama
    // urutan dgn Kas Bank - nama file (ber-UUID) baru dikirim setelah upload
    // selesai/gagal, supaya kolom "File" tak pernah menunjuk ke file yang
    // belum sungguh-sungguh ada di server tanpa pemberitahuan.
    if (selectedFile) {
      setIsUploading(true);
      const uuid = uuidv4();
      const safeFileName = selectedFile.name.replace(/\s+/g, "_");
      const fileNameWithUUID = `${uuid}-${safeFileName}`;
      try {
        const formData = new FormData();
        formData.append("file", selectedFile, fileNameWithUUID);
        await mutationFileUpload.mutateAsync(formData);
        setUploadedFileName(fileNameWithUUID);
        setFileUploadError(false);
        toast.success("File berhasil diupload", { position: "bottom-right", autoClose: 2000 });
      } catch (uploadError) {
        setFileUploadError(true);
        toast.warning(
          "Upload file gagal, tetapi nama file tetap disimpan di database. File tidak akan tersedia untuk di-download.",
          { position: "bottom-right", autoClose: 4000 }
        );
      } finally {
        setIsUploading(false);
      }
      newValues["File"] = fileNameWithUUID;
    } else {
      newValues["File"] = uploadedFileName || values.File || "";
    }

    if (params.transid) {
      newValues["Status"] = "-1";
      mutationUpdate.mutate(newValues);
    } else {
      mutationAdd.mutate(newValues);
    }
  };

  function TambahAccount(e) {
    console.log(e);
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() => navigate("/finance/pembayaran-ap")}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>
                  {params.transid && values.Status === "Approved" && (
                    <button
                      onClick={() => {
                        if (window.confirm("Rollback approval PA " + params.transid + "? Jurnal, CashJournal, dan Accounting akan dihapus.")) {
                          mutationRollback.mutate(params.transid, {
                            onSuccess: () => {
                              mutationGet.mutate(params.transid);
                            },
                          });
                        }
                      }}
                      disabled={mutationRollback.isLoading}
                      className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-red-600 hover:text-white text-red-600 font-semibold py-2 px-4 border border-red-400 shadow rounded disabled:opacity-50"
                    >
                      {mutationRollback.isLoading ? "Loading..." : "Rollback"}
                    </button>
                  )}
                  <button
                    onClick={() => Kirim()}
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentColor"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Simpan"
                    )}
                  </button>
                </div>

                {/* Status Pembayaran Alert */}
                {loadingCheck && (
                  <div className="mb-4 p-3 bg-blue-100 border border-blue-300 rounded">
                    <div className="flex items-center">
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline mr-3 w-4 h-4 text-blue-500 animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                      Memeriksa status pembayaran...
                    </div>
                  </div>
                )}

                {paymentStatus && !loadingCheck && (
                  <div className={`mb-4 p-3 rounded border ${paymentStatus.isPaid ? 'bg-yellow-100 border-yellow-300 text-yellow-800' : 'bg-green-100 border-green-300 text-green-800'}`}>
                    <div className="flex items-center">
                      {paymentStatus.isPaid ? (
                        <>
                          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          <span className="font-semibold">Perhatian!</span>
                        </>
                      ) : (
                        <>
                          <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                          <span className="font-semibold">Status:</span>
                        </>
                      )}
                    </div>
                    <p className="mt-1 ml-7">
                      {paymentStatus.message}
                      {paymentStatus.isPaid && (
                        <>
                          <br />
                          <span className="text-sm">
                            <strong>Keterangan:</strong> {paymentStatus.keterangan}
                            {paymentStatus.tanggal && (
                              <>
                                <br />
                                <strong>Tanggal:</strong> {new Date(paymentStatus.tanggal).toLocaleDateString()}
                              </>
                            )}
                            {paymentStatus.nominal && (
                              <>
                                <br />
                                <strong>Nominal:</strong> Rp {parseFloat(paymentStatus.nominal).toLocaleString('id-ID')}
                              </>
                            )}
                            {paymentStatus.cashJournalID && (
                              <>
                                <br />
                                <strong>Cash Journal ID:</strong> {paymentStatus.cashJournalID}
                              </>
                            )}
                          </span>
                        </>
                      )}
                    </p>
                  </div>
                )}

                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"GetGoodsAcceptancePembayaran"}
                    value={values}
                    name={"SumberData"}
                    title={"Sumber Data"}
                    onChange={sumberDataHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={false}
                  />
                </div>
                <div className="w-1/3">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"PurchaseOrderID"}
                    title={"Purchase Order"}
                    onChange={sumberDataHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className="w-1/3 mb-5">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"DibayarKepada"}
                    title={"Dibayar Kepada"}
                    onChange={sumberDataHandler}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <hr className={"w-full mb-6"} />

                <div className={"grid md:grid-cols-2"}>
                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"JenisPenerimaan"}
                      value={values}
                      name={"JenisCashJournal"}
                      title={"Jenis Pembayaran"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={false}
                    />
                  </div>
                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"MataUang"}
                      title={"Mata Uang"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                </div>

                {/* Lampiran data pendukung - pola sama dgn Attachment di Kas Bank */}
                <div className="w-full px-3 mb-4">
                  <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                    Lampiran Data Pendukung
                    {selectedFile && (
                      <span className="text-green-600 text-xs ml-2">✓ File siap diupload</span>
                    )}
                    {(uploadedFileName || values.File) && !selectedFile && (
                      <span className="text-blue-600 text-xs ml-2">✓ File tersedia</span>
                    )}
                  </label>
                  <div className="flex items-center space-x-2">
                    <button
                      type="button"
                      onClick={() => fileInputRef.current.click()}
                      className="bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-300 rounded shadow-sm transition-colors duration-200"
                    >
                      {displayFileName ? "Ganti File" : "Pilih File"}
                    </button>
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      onChange={handleFileChange}
                    />
                    {(uploadedFileName || values.File) && !selectedFile && (
                      <button
                        type="button"
                        onClick={() => getDataFromURL(values.File || uploadedFileName)}
                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 border border-blue-600 rounded shadow-sm transition-colors duration-200"
                      >
                        Lihat File
                      </button>
                    )}
                    {(selectedFile || uploadedFileName || values.File) && (
                      <button
                        type="button"
                        onClick={removeFile}
                        className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 border border-red-600 rounded shadow-sm transition-colors duration-200"
                      >
                        Hapus
                      </button>
                    )}
                  </div>
                  {displayFileName && (
                    <div className="mt-2 p-2 bg-gray-50 rounded border">
                      <span className="text-sm text-gray-700 truncate">{displayFileName}</span>
                      {isUploading && (
                        <div className="mt-2 text-xs text-blue-600">Mengupload file...</div>
                      )}
                      {fileUploadError && (
                        <div className="mt-2 text-xs text-yellow-600">
                          Nama file disimpan, tetapi upload gagal
                        </div>
                      )}
                    </div>
                  )}
                </div>

                <div className={"grid md:grid-cols-2"}>
                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"DetailPembayaran"}
                      value={values}
                      name={"DetailCashJournal"}
                      title={"Detail Pembayaran"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={false}
                    />
                  </div>
                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"number"}
                      value={values}
                      name={"KonversiRupiah"}
                      title={"Konversi Rupiah"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={false}
                    />
                  </div>
                </div>
                <div className={"grid md:grid-cols-2"}>
                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"dateOnly"}
                      value={values}
                      name={"Tanggal"}
                      title={"Tanggal"}
                      onChange={customHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={false}
                    />
                  </div>
                  <div className="w-1/2">
                    {values.JenisCashJournal === "Bank" && (
                      <HrdInputGenerator
                        type={"text"}
                        value={values}
                        name={"NoCek"}
                        title={"No.Cek/Bilyet"}
                        onChange={changeHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    )}
                  </div>
                </div>
                <div className={"grid md:grid-cols-2"}>
                  <div className="w-1/2"></div>
                  <div className="w-1/2">
                    {values.JenisCashJournal === "Bank" && (
                      <HrdInputGenerator
                        type={"dateOnly"}
                        value={values}
                        name={"TanggalCek"}
                        title={"Tanggal Cek"}
                        onChange={customHandler}
                        touched={touched}
                        buttonTouched={buttonTouched}
                        size={"full"}
                        required={true}
                        errors={errors}
                        disabled={false}
                      />
                    )}
                  </div>
                </div>
                <div className={"grid md:grid-cols-2"}>
                  <div className="w-full">
                    <HrdInputGenerator
                      type={"text"}
                      value={values}
                      name={"Keterangan"}
                      title={"Keterangan"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={false}
                    />
                  </div>

                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"numberFormatSatu"}
                      value={values}
                      name={"Nominal"}
                      title={"Nominal"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                </div>
                {/* Referensi Downpayment — READ ONLY.
                    Uang muka dipilih saat MSR dibuat, lalu terbawa ke PO lewat
                    PRComparison. Tidak bisa diubah di sini: backend selalu
                    menurunkannya ulang dari MSR saat menyimpan, jadi pilihan manual
                    apa pun akan diabaikan. */}
                <div className="mx-2 mb-3">
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Referensi Downpayment PO
                  </label>
                  {selectedDownpayment ? (
                    <>
                      <div className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-gray-50 text-gray-700">
                        {selectedDownpayment.CashJournalID} |{" "}
                        {selectedDownpayment.DariKepada} | Rp{" "}
                        {parseFloat(selectedDownpayment.Nominal).toLocaleString("id-ID")} |{" "}
                        {selectedDownpayment.Tanggal}
                      </div>
                      {(() => {
                        // Uang muka dipakai maksimal sebesar nominal termin;
                        // kelebihannya mengendap untuk termin berikutnya.
                        const tersedia =
                          parseFloat(selectedDownpayment.Nominal) || 0;
                        const nominalTermin = parseFloat(values.Nominal) || 0;
                        const terpakai = Math.min(tersedia, nominalTermin);
                        const sisa = tersedia - terpakai;
                        const rp = (n) =>
                          `Rp ${parseFloat(n || 0).toLocaleString("id-ID")}`;
                        return (
                          <div className="mt-1 text-xs text-blue-700">
                            Uang muka tersedia <strong>{rp(tersedia)}</strong>
                            &nbsp;—&nbsp; dipakai termin ini{" "}
                            <strong>{rp(terpakai)}</strong>
                            &nbsp;—&nbsp; Nilai Bayar ={" "}
                            <strong>{rp(values.NilaiBayar || 0)}</strong>
                            {sisa > 0 && (
                              <>
                                <br />
                                Sisa <strong>{rp(sisa)}</strong> tetap tercatat
                                sebagai uang muka dan bisa dipakai termin
                                berikutnya.
                              </>
                            )}
                            <br />
                            Berasal dari MSR PO ini — ubah di form MSR bila
                            keliru.
                          </div>
                        );
                      })()}
                    </>
                  ) : (
                    <div className="w-full border border-gray-200 rounded px-3 py-2 text-sm bg-gray-50 text-gray-400">
                      Tidak ada uang muka pada MSR PO ini
                    </div>
                  )}
                </div>

                <div className={"grid md:grid-cols-2"}>
                  <div className="w-full"></div>

                  <div className="w-1/2">
                    <HrdInputGenerator
                      type={"numberFormatSatu"}
                      value={values}
                      name={"NilaiBayar"}
                      title={"Nilai Bayar"}
                      onChange={changeHandler}
                      touched={touched}
                      buttonTouched={buttonTouched}
                      size={"full"}
                      required={true}
                      errors={errors}
                      disabled={true}
                    />
                  </div>
                </div>

                <hr />
                <DynamicTableSimple
                  data={detail}
                  header={header}
                  Master={true}
                  OnClick={ModalOpener}
                  name={"Purchase Requisition"}
                  barang={barang.data}
                  edit={ModalEdit}
                  delete={ModalDelete}
                  account={detailAccount.data}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                {showModalEdit ? "Edit Data" : "Tambah Data"}
              </ModalHeader>
              <ModalBody>
                <form className="w-full " onSubmit={submitHandler}>
                  {inputBuilder.map(
                    (
                      {
                        type,
                        name,
                        title,
                        handler,
                        modifiers,
                        size,
                        required,
                        disabled,
                        edit,
                      },
                      id
                    ) => {
                      if (!edit || showModalEdit) {
                        return (
                          <HrdInputGenerator
                            type={type}
                            value={modalDetail}
                            name={name}
                            title={title}
                            onChange={handler}
                            touched={touched}
                            buttonTouched={buttonTouched}
                            modifiers={modifiers}
                            size={size}
                            required={required}
                            errors={errors}
                            disabled={disabled}
                          />
                        );
                      }
                    }
                  )}
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                    setShowModalEdit(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  color={isValid || !isValid ? "green" : "blueGray"}
                  disabled={mutation.isLoading}
                  onClick={(e) => {
                    TambahAccount(e);
                    if (!isValid && changed) {
                      setButtonTouched(true);
                    }
                    if (showModalEdit) {
                      let newValues = [...detail];
                      newValues[modalID] = modalDetail;
                      let totals = 0;
                      newValues.forEach(({ Nominal }) => {
                        totals += parseFloat(Nominal) || 0;
                      });
                      customHandler(parseFloat(values.Nominal || 0) + totals, "NilaiBayar");
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                      setShowModalEdit(false);
                    } else {
                      const newValues = [...detail, modalDetail];
                      let totals = 0;
                      newValues.forEach(({ Nominal }) => {
                        totals += parseFloat(Nominal) || 0;
                      });
                      customHandler(parseFloat(values.Nominal || 0) + totals, "NilaiBayar");
                      setDetail(newValues);
                      setModalDetail(initialStateModal);
                      setShowModal(false);
                    }
                  }}
                  ripple={isValid ? "light" : ""}
                >
                  {showModalEdit ? "Ubah" : "Tambah"}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertAccountPayable;